import React from 'react';

import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router';

import { NavMenu } from '../../@types/global';
import { VideaButton } from '../../common-components/elements/VideaButton/VideaButton';
import { videaInsightsMenuOptions } from '../../constants';
import routes from '../../routes/routes.constants';
import {
  blueBlack400,
  blueBlack500,
  blueBlack640,
  white,
} from '../../theme/videa-style-tokens';
import { colors } from '../../utils/theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: colors.OFF_WHITE,
    height: '100%',
    paddingLeft: '1.125em',
  },
  menuContainer: {
    marginTop: '1em',
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0.5em 0',
    cursor: 'pointer',
    padding: '0.25em 1em 0.25em 0.5em',
    width: '9.5em',
    backgroundColor: colors.DIM_WHITE,
    color: blueBlack640,
    borderRadius: '0.25em',
    whiteSpace: 'nowrap',

    '& .MuiTypography-root': {
      marginLeft: '0.5em',
      fontSize: '0.75rem',
    },

    '&:hover': {
      backgroundColor: blueBlack400,
      color: white,
    },

    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
  menuSelected: {
    backgroundColor: blueBlack640,
    color: white,
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
    '&:hover': {
      color: colors.DIM_WHITE,
      backgroundColor: blueBlack500,
    },
  },
  divider: {
    margin: `${theme.spacing(3)} auto`,
    height: '1.5px',
  },
}));

interface Props {
  className?: string;
}

const Navbar = ({ className }: Props) => {
  const classes = useStyles();
  const history = useHistory();

  const [selectedMenu, setSelectedMenu] = React.useState<string>(
    NavMenu.DASHBOARD,
  );

  React.useEffect(() => {
    if (history) {
      const unlisten = history.listen((location) => {
        let selectedMenuItem = null;
        if (location.pathname === routes.VIDEA_INSIGHT_DASHBOARD) {
          selectedMenuItem = NavMenu.DASHBOARD;
        } else if (location.pathname === routes.VIDEA_INSIGHT_LOCATIONS) {
          selectedMenuItem = NavMenu.LOCATIONS;
        }
        // @ts-expect-error TS(2345): Argument of type 'import("/Users/matt/videa/videa-... Remove this comment to see the full error message
        setSelectedMenu(selectedMenuItem);
      });

      let selectedMenuItem = null;
      if (history.location.pathname === routes.VIDEA_INSIGHT_DASHBOARD) {
        selectedMenuItem = NavMenu.DASHBOARD;
      } else if (history.location.pathname === routes.VIDEA_INSIGHT_LOCATIONS) {
        selectedMenuItem = NavMenu.LOCATIONS;
      }
      // @ts-expect-error TS(2345): Argument of type 'import("/Users/matt/videa/videa-... Remove this comment to see the full error message
      setSelectedMenu(selectedMenuItem);

      return () => {
        unlisten();
      };
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps -- React Hook React.useEffect has a missing dependency: 'history'. Either include it or remove the dependency array. */
  }, []);

  const setSelectedClass = (menu: any) =>
    selectedMenu === menu.name ? classes.menuSelected : null;

  const menus = videaInsightsMenuOptions.map((menu) => (
    <VideaButton
      key={menu.name}
      className={`${classes.menu} ${setSelectedClass(menu)}`}
      onClick={() => {
        setSelectedMenu(menu.name);
        history.push(menu.path);
      }}
    >
      <menu.icon />
      <Typography>{menu.name}</Typography>
    </VideaButton>
  ));

  return (
    <div className={`${classes.root} ${className}`}>
      <div className={classes.menuContainer}>{menus}</div>
    </div>
  );
};

export default Navbar;
